export default function Close({
    style,
    fill="#536987",
}){
    return <svg style={style} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20 12L11 21" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 12L20 21" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>       
}